import { useClientPortalAPI } from "@certn/api";

export function useCheckArgumentsTemplatesInPackages(): string[] {
  const { data: packages } = useClientPortalAPI(
    "/api/internal/client-portal/packages/"
  );

  if (!packages) {
    return [];
  }

  const templateIds = new Set<string>();

  packages.results?.forEach((pkg) => {
    pkg.packagecheck_set?.forEach((check) => {
      const checkArgs = check.arguments as Record<string, unknown>;
      const templateId = checkArgs?.template_id;
      if (typeof templateId === "string") {
        templateIds.add(templateId);
      }
    });
  });

  return Array.from(templateIds);
}
